export class Texto_sitio {
  spain = {
    menu: {
      items: [
        {
          nombre: "Mi Cuenta"
        },
        {
          nombre: "Viajes"
        },
        {
          nombre: "Puntos"
        },
        {
          nombre: "Mis Viajeros"
        },
        {
          nombre: "Gestión boletos"
        },
        {
          nombre: "Buses"
        },
        {
          nombre: "Servicio al Cliente"
        },
        {
          nombre: "Gestión Boletos"
        },
        {
          nombre: "Mapa del Sitio"
        },
        {
          nombre: "Términos y condiciones"
        },
        {
          nombre: "Políticas de privacidad"
        },
        {
          nombre: "Políticas de cookies"
        },
        {
          nombre: "Cupones"
        },
        {
          nombre: "Cerrar Sesión"
        },
        {
          nombre: "Traslados"
        },
        {
          nombre: "Anul/Cambios"
        },
        {
          nombre: 'Servicios'
        },
        {
          nombre: 'Gestión de boletos y mapa'
        },
        {
          nombre:'Términos y privacidad'
        },
        {
          nombre: 'Políticas y ayuda'
        }
      ],
      mi_cuenta: "MI CUENTA ",
      que_buscas: "QUE BUSCAS?",
      informacion: "INFORMACIÓN",
      siguenos: "SIGUENOS"
    },
    contenedor: {
      titulo: "Pasajes en bus | Compra tu pasaje al mejor precio",
      subtitulo: "Consigue el mejor precio en más de 2.000 destinos en",
      subtitulo2: "Chile y Argentina.",
      cupones_descuentos_titulo: "Cupones & Descuentos",
      cupones_descuentos_texto_1: "Cada vez que viajas acumulas puntos",
      cupones_descuentos_texto_2: "(Programa viajero frecuente).",
      descuento_cliente_frecuente: "Descuento Cliente Frecuente",
      aplicar_descuento: "Aplicar descuento",
      ahorra_dinero_titulo: "Ahorra Dinero",
      ahorra_dinero_texto: "Comparamos los demas sitios web de viajes para entregarte el mejor precio.",
      sitio_seguro_titulo: "Sitio Seguro",
      sitio_seguro_texto: "Chilepasajes.cl cuenta con certificado de seguridad SSL EV.",
      titulo_principal: "Pasajes en bus baratos",
      titulo_principal2: "para tu próximo viaje",
      ultimasBusquedas: "Últimas búsquedas realizadas",
      a: " a ",
      pasajesA: "Pasajes a ",
      paraEl: ", para el ",
      servicioTranfer:"Descubre nuestro servicio de Transfer",
      teTrasladamos: "Te trasladamos entre comunas, terminales de buses y aeropuerto. Solicita nuestro servicio de transfer y viaja con más tranquilidad a diferentes destinos dentro de Santiago y Regiones.",
      comoSolicitarlo: "¿Cómo solicitarlo?",
      seleccionaPestania: "Selecciona la pestaña “Transfer” en la sección de compra de boletos e ingresa tu lugar de origen, destino y hora en que viajarás. A continuación compartimos algunos consejos que te podrían ser de utilidad a la hora de viajar y agendar tu transfer.",
      planificaTuViaje: "Planifica tu viaje, este servicio debe ser solicitado al menos con 24 horas de anticipación.",
      recuerdaOrganizar: "Recuerda organizar tu equipaje y tener todo listo antes de que llegue tu transporte.",
      queremosQueLlegues: "Queremos que llegues a tiempo a tu destino, recuerda agendar considerando la hora de tu viaje."
    },
    contenedor_transfer: {
      titulo: "Pasajes en bus | Compra tu pasaje al mejor precio",
      subtitulo: "Reserva tu traslado al mejor precio!",
      subtitulo2: "Chile y Argentina.",
      cupones_descuentos_titulo: "Cupones & Descuentos",
      cupones_descuentos_texto_1: "Cada vez que viajas acumulas puntos",
      cupones_descuentos_texto_2: "(Programa viajero frecuente).",
      ahorra_dinero_titulo: "Ahorra Dinero",
      ahorra_dinero_texto: "Comparamos los demas sitios web de viajes para entregarte el mejor precio.",
      sitio_seguro_titulo: "Sitio Seguro",
      sitio_seguro_texto: "Chilepasajes.cl cuenta con certificado de seguridad SSL EV.",
      titulo_principal: "Transfer, traslados hacia y desde el aeropuerto",
      titulo_principal2: "para tu próximo viaje.",
      ultimasBusquedas: "Últimas búsquedas realizadas",
      a: " a ",
      transferPara: "Transfer para el ",
      aLas: " a las ",
      hrs: " hrs."
    },
    list_services: {
      capacidad: "Capacidad",
      pasajeros: "pasajero(s)",
      desde: "Desde",
      cant_pasajeros: "Cantidad pasajeros",
      reservar: "Reservar"
    },
    barra_busqueda: {
      origen: "Origen",
      destino: "Destino",
      fecha_ida: "Fecha de ida",
      fecha:"Fecha",
      hora: "Hora",
      fecha_vuelta: "Regreso (Opc)",
      horaIda: "Hora ida",
      placeholderIda: "¿Desde donde viajas?",
      placeholderVuelta: "¿Donde quieres ir?",
      placeholderFechaIda: "Fecha ida",
      placeholderFechaVuelta: "Fecha regreso",
      ingresaOrigen: "Ingresa tú <b>Origen</b>",
      ingresaDestino: "Ingresa tú <b>Destino</b>",
      buscar: "Buscar",
      placeholderIdaT: "Escriba o seleccione origen",
      placeholderVueltaT: "Escriba o seleccione destino",
      pasajes_en_bus: "Pasajes en bus",
      a: "a",
      para_el_dia: "para el dia",
      modificar: "Modificar"
    },
    pre_nav: {
      salidas: "Salidas",
      salida: "Salida",
      salidas_text: "Selecciona tu viaje",
      salidas_reg: "Salidas Regreso",
      salidas_text_reg: "Selecciona tu viaje",
      pago: "Pago",
      pago_text: "Seleccione su método de pago",
      confirmacion: "Confirmación",
      confirmacion_text: "Confirmación de la compra",
      ida: "Ida",
      regreso: "Regreso",
      seleccionada: "Seleccionada",
      llegada: 'Llegada'
    },
    tarjeta_empresa: {
      primera_salida: "Primera salida",
      ultima_salida: "Última salida",
      duracion: "Duración",
      salidas: "Salidas",
      salida: "Salida"
    },
    filtros: {
      embarque: "Embarque Electrónico",
      embarque_text: "Permite subir al bus sin tener el pasaje impreso",
      precio: "Precio",
      horario: "Horario",
      empresas: "Empresas",
      salidas_desde: "Salidas desde",
      servicios: "Servicios",
      servicio: "Servicio",
      desde: "Desde",
      operador: "Operadores",
      clase: "Clase",
      limpiar_filtros: "Limpiar filtros",
      cargando: "Estamos buscando el mejor precio",
      cargando_2: "Espera por favor !!!",
      mañana: "Mañana",
      tarde: "Tarde",
      noche: "Noche",
      madrugada: "Madrugada",
      embarque_electronico: "Emb. electrónico",
      mejor_precio: "Mejor Precio",
      elegir: "Elegir",
      modificar: "Modificar",
      seleccionar: "Seleccionar",
    },
    asientos: {
      primer_piso: "Primer piso",
      segundo_piso: "Segundo piso",
      disponible: "Disponible",
      seleccionado: "Seleccionado",
      reservado: "Reservado",
      num_asiento: "N° de Asiento ",
      tarifa_clp: "Tarifa CLP ",
      tarifa_usd: "Tarifa USD ",
      tipo_asiento: "Tipo de asiento ",
      continuar: "Continuar",
      pasillo: "PASILLO",
      ida: "IDA",
      vuelta: "REGRESO",
      conductor: "Conductor",
      cargando: "Cargando asientos ...",
    },
    tarjeta_pago: {
      ida: "Ida",
      regreso: "Regreso",
      pasajero: "Pasajero",
      asiento: "Asiento",
      pasaporte: "Pasaporte/Otros",
      rut: "Rut",
      rutPlaceholder: "Rut",
      nombre: "Nombre",
      nombrePlaceholder: "Nombre",
      apellido: "Apellido",
      pais: "Pais",
      subida: "Subida",
      bajada: "Bajada",
      misPasajeros: "Mis pasajeros",
      comprador: "Información del comprador",
      telefono: "Teléfono",
      telefonoPlaceholder: "Teléfono",
      correo: "Correo",
      confirmar_correo: "Confirmar correo",
      cupon: "Cupón de descuento",
      aplicarCupon: "Aplicar cupón",
      detalleCompra: "Detalle compra",
      SubTotal: "Sub total",
      descuento: "Descuento",
      totalCompra: "Total de la compra",
      pagarCompra: "Pagar compra",
      terminos: "Términos y condicionaes.",
      terminos_text: `Al presionar sobre "Pagar Compra" acepta los`,
      regresar: "Regresar",
      minimo_digitos: "Mínimo 8 dígitos",
      maximo_digitos12: "Máximo 12 dígitos",
      maximo_digitos15: "Máximo 15 dígitos",
      maximo_digitos9: "Máximo 9 dígitos",
      rut_invalido: "Rut inválido",
      requerido: "Requerido",
      correo_invalido: "Correo inválido",
      correos_diferentes: "Los correos deben ser iguales",
      solo_letras: "Sólo letras",
      fecha_nacimiento: "Fecha nacimiento",
      telefono_invalido: "Teléfono inválido",
      pago: "Pago",
      metodosPago: "Métodos de pago",
      seguro: "Seguro",
      viajeAeropuerto: 'Viaje En Bus Al Aeropuerto Ida/Reg',
      extra: 'Añadir a la compra'
    },
    medio_pago: {
      distintasOpciones: "Multiples opciones de pago",
      EstasSon: "Estas son las opciones mediante las cuales puedes realizar tus compras."
    },
    gestion_boletos:{
      titulo: 'Gestión de boletos',
      inicio: 'Inicio',
      servicio_cliente: 'Servicio al cliente',
      informacion: 'Información de la compra',
      codigo_compra: 'Código de compra',
      requerido: 'Requerido',
      correo: 'Correo',
      correo_info: 'Email usado en la compra',
      correo_invalido: 'Correo inválido',
      buscar: 'Buscar'
    },
    servicio_cliente: {
      titulo: 'Servicio al cliente',
      inicio: 'Inicio',
      busqueda: {
        titulo: 'Búsquedas',
        buscar_sitio: 'Búsquedas en el sitio',
        duda: '¿Tienes alguna duda de como realizar una búsqueda?',
        comoBuscar: '¿Cómo hacer una búsqueda?',
        infoBuscar: ' Para realizar una busqueda en nuestro sitio, sólo deberá \ningresar la ciudad de origen, tu destino y la fecha. Se \nle mostrara un resumen completo de la oferta de buses \nque existe para ese día. Si usted quiere comprar un \npasaje de ida-vuelta, sólo ingresa una fecha de retorno.',
        cambiarBuscar: '¿Hice una búsqueda y ahora quiero cambiarla ¿Cómo lo \nhago?',
        infoCambiar: 'Sólo deberá ingresar la nueva ruta en el sistema de búsqueda en la parte superior de la página.',
        demoraBuscar: 'La búsqueda demora algo de tiempo ¿Por qué?',
        infoDemora: 'Para encontrar el viaje que buscas, tenemos que reunir \nmucha información y comunicarnos en linea con cada una \nde las empresas de buses que operan la ruta buscada, \na veces estas empresas demoran en contestar las llamadas \ny eso genera un tiempo mas prolongado en mostrar los \nresultados, solo debes esperar.',
        filtrar: '¿Puedo ordenar y filtrar mis resultados?',
        infoFiltrar: 'Sí, puedes ordenar y filtrar tus resultados aplicando \ndiferentes filtros. Estos filtros son: precio, servicio \ny tiempo. Los puedes encontrar al lado izquierdo de la \npágina que muestra los resultados. Para hacer tu \nbúsqueda aún más precisa puedes usar el horario de \nsalida y/o la barra de precio máximo/mínimo y ajustar \ntus resultados.'
      },
      pago: {
        titulo: 'Pagos',
        ayuda: '¿Ayuda con tu proceso de pago?',
        metodos: '¿Qué métodos de pago ofrece Chilepasajes.cl?',
        webPay:{
          titulo: 'WebPay',
          info: 'Es el método de pago más común y \nseguro en Chile. Lo recomendamos para nuestros \nclientes que tienen una cuenta bancaria chilena \nporque la moneda de compra es el Peso Chileno (CLP) \ny WebPay no permite devoluciones al extranjero. \nPuedes pagar tus pasajes con tu cuenta bancaria \nchilena, tu tarjeta de crédito o débito.'
        },
        infoPaypal:'Es el método de pago más común y \nseguro a nivel mundial. Lo recomendamos para \nnuestros clientes del extranjero, porque la moneda \ndel pago es el dólar estadounidense y PayPal no \ntiene límites regionales para la devolución como WebPay',
        tarjetaHites:{
          titulo: 'Tarjeta Hites',
          info: 'Esta compra es procesada por Hites'
        }
      },
      pasajes:{
        titulo: 'Envío de pasajes',
        ayuda: '¿Necesitas ayuda con tus pasajes?',
        demoraPasajes:{
          titulo: '¿Cómo recibo mi pasaje y cuánto tiempo se demora?',
          texto1: 'Al finalizar su compra puedes descargar inmediatamente tu comprobante en formato PDF.',
          textoNegrita1: 'Recomendamos descargar su pasaje inmediatamente.',
          texto2: 'Simultáneamente se te enviará un correo electrónico de confirmación que incluye tu comprobante/pasaje y la tarjeta de Embarque e información de viaje. Además, si tienes un smartphone con sistema Android o iOS, puedes descargar tu pasaje en la app de Chilepasajes y entrar al bus con un pasaje móvil si la empresa de bus lo permite.',
          texto3: 'Si no recibes el pasaje, te recomendamos que revisas tu buzón de correo electrónico y si el pasaje fue clasificado por error como SPAM muévalo a su bandeja de entrada.',
          texto4: 'Si eso no ayuda o si ingresaste mal tu correo electrónico al momento de la compra, tienes que escribirnos por lo menos 24 horas antes de la salida del bus a ',
          texto5:'o contactarnos al siguiente número de atención al cliente:',
          texto6:'para reenviar su boleto.'
        }
      },
      cancelaciones: {
        titulo: 'Cancelaciones',
        duda: '¿Tienes alguna duda sobre tu anulación?',
        botonCancelar: 'Cancelar pasajes',
        pregunta1:{
          titulo: '¿Quiero anular mi pasaje y recibir una devolución, que cosas tengo que considerar?',
          texto1: 'Tienes que revisar las condiciones de anulación descritas en pasaje. Generalmente, puedes anular cada pasaje a través de chilepasajes.cl ingresando a',
          texto2: 'Cada empresa del bus acepta anulaciones de viajes nacionales hasta 4 horas antes de la salida, junto con una retención de 15%, En el caso de viajes internacionales la anticipación de anular el pasaje puede ser hasta 72 horas antes de la salida del bus. Recomendamos revisar bien las condiciones de anulación en el caso de tu viaje.'
        },
        pregunta2:{
          titulo:'¿Cómo puedo anular mi pasaje?',
          texto1: 'Solo tienes que hacer un clic en el enlace',
          texto2: 'en la sección del "Servicio al cliente" en nuestra página principal. Recuerda que solo puedes anular tu pasaje si la anulación cumple con las condiciones de anulación, especialmente que cumple con el tiempo de anticipación antes de la salida del bus. Después tienes que ingresar el correo electrónico que usaste y tu código de compra y hacer clic en "Buscar". Después te mostramos los pasajes que se pueden anular. Para anular tu pasaje tienes que hacer clic en “Anular pasaje” al lado del pasaje que quieres anular, elegir entre Cupón o Deposito Bancario. Para finalizar la anulación es importante que ingresas tus datos bancarios para realizar la devolución (solo si compraste vía WebPay). Después chilepasajes.cl te confirmará la anulación mediante el envío de un correo electrónico.'
        },
        pregunta3:{
          titulo: '¿Cómo funciona el proceso de la devolución?',
          texto1: 'El proceso de la devolución depende del método de pago que usaste para comprar tu pasaje:',
          texto2: 'El plazo para el depósito es de 5 días hábiles en el caso de compra con tarjeta de débito, mientras que si compraste con tarjeta de crédito el plazo es de 10 días hábiles. El plazo inicia desde el día hábil posterior a la recepción de sus datos bancarios para transferencia, si una vez cumplido este plazo tiene algún inconveniente con su pago no dude en comunicarse con nosotros a través de ayuda@chilepasajes.cl, indicando el número de compra y tus datos bancarios (titular de la cuenta, RUT del titular, nombre del banco, tipo de cuenta).',
          texto3: 'La devolución se realizará a la cuenta de PayPal que el cliente ha usado para la compra. En caso que no recibas la devolución en tu cuenta 7 días después de tu cancelación, por favor contactarnos a través de ayuda@chilepasajes.cl, indicando el número de compra y tu cuenta de PayPal.'
        }
      },
      preguntas:'¿Aún tienes una pregunta?',
      infoPregunta:'Si no puede encontrar una pregunta en nuestras Preguntas Frecuentes, siempre puede contactar nosotros. ¡Te responderemos en breve!',
      infoTel:'¡Siempre estamos felices de ayudar!',
      infoMail: '¡La mejor manera de obtener una respuesta rápida!'
    },
    footer:{
      tituloBoletos: 'Gestiona tus boletos: anula, cambia, cambia paradero, etc.',
      tituloTermYcond:'Lea los Términos y Condiciones de uso del sitio.',
      tituloPrivacidad: 'Lea las Politicas de privacidad del sitio.',
      tituloBuses: 'Ir al buscador de pasajes',
      tituloTransfer: 'Ir al buscador de transfer',
      tituloCookies: 'Lea las Politicas de cookies del sitio',
      tituloInfo: 'Lea información útil sobre el sitio',
      tituloVolver: 'Volver al principio de la página',
      tituloFacebook: 'Ir a la página de Facebook de ChilePasajes',
      tituloX: 'Ir a la página de X de ChilePasajes',
      tituloInstagram: 'Ir a la página de Instagram de ChilePasajes',
      tituloYoutube: 'Ir al Canal de Youtube de ChilePasajes'
    },
    login:{
      bienvenido: 'Bienvenid@ a Chilepasajes.cl ! 👋',
      inicia: 'Inicia sesión en tu cuenta, y comienza la aventura de viajar junto a nosotros.',
      contrasena: 'Contraseña',
      recordarme: 'Recordarme',
      ingresar: 'Ingresar',
      aceptarTerminos: 'Al iniciar sesión, aceptas nuestros',
      terminosUso: 'términos de uso',
      politicas: 'política de privacidad',
      nuevo: 'Nuevo en la plataforma?',
      crearCuenta: 'Crear una cuenta',
      recuperar:'Recuperar contraseña'
    },
    empresas:
    {
      pasajesen:"pasajes en "
    }
  }

  english = {
    menu: {
      items: [
        {
          nombre: "My account"
        },
        {
          nombre: "Trips"
        },
        {
          nombre: "Points"
        },
        {
          nombre: "My travelers"
        },
        {
          nombre: "Cancellations"
        },
        {
          nombre: "Buses"
        },
        {
          nombre: "Customer service"
        },
        {
          nombre: "Cancel tickets"
        },
        {
          nombre: "Site Map"
        },
        {
          nombre: "Terms and conditions"
        },
        {
          nombre: "Privacy policies"
        },
        {
          nombre: "Cookie policies"
        },
        {
          nombre: 'Coupons'
        },
        {
          nombre: 'Log out'
        },
        {
          nombre: 'Transfer'
        },
        {
          nombre: 'Cancel/changes'
        },
        {
          nombre: 'Services'
        },
        {
          nombre: 'Ticket and Map management'
        },
        {
          nombre: 'Terms and Privacy'
        },
        {
          nombre: 'Policies and help'
        }
      ],
      mi_cuenta: "MY ACCOUNT",
      que_buscas: "WHAT ARE YOU LOOKING FOR?",
      informacion: "INFORMATION",
      siguenos: "FOLLOW US"
    },
    contenedor: {
      titulo: "Bus tickets | Buy your ticket at the best price",
      subtitulo: "Get the best price in more than 2,000 destinations in",
      subtitulo2: "Chile and Argentina",
      cupones_descuentos_titulo: "Coupons & Discounts",
      cupones_descuentos_texto_1: "Every time you travel you accumulate points",
      cupones_descuentos_texto_2: "(Frequent flyer program).",
      descuento_cliente_frecuente: "Frequent Customer Discount",
      aplicar_descuento: "Apply discount",
      ahorra_dinero_titulo: "Save money",
      ahorra_dinero_texto: "We compare other travel websites to give you the best price.",
      sitio_seguro_titulo: "Safe zone",
      sitio_seguro_texto: "Chilepasajes.cl has an EV SSL security certificate.",
      titulo_principal: "Find cheap bus tickets",
      titulo_principal2: "for your next trip",
      ultimasBusquedas: "Last searches performed",
      a: " to ",
      pasajesA: "Tickets to ",
      paraEl: ", by ",
      servicioTranfer:"Discover our transfer service",
      teTrasladamos: "We transfer you between communities, bus terminals and airports. Request our transfer service and travel with more tranquility to different destinations within Santiago and regions.",
      comoSolicitarlo: "How to apply?",
      seleccionaPestania: "Select the “Transfer” tab in the ticket purchase section and enter your place of origin, destination and time of travel. Here are some tips that may be useful when traveling and scheduling your transfer.",
      planificaTuViaje: "Plan your trip, this service must be requested at least 24 hours in advance.",
      recuerdaOrganizar: "Remember to organize your luggage and have everything ready before your transportation arrives.",
      queremosQueLlegues: "We want you to arrive on time to your destination, remember to schedule considering the time of your trip."
    },
    contenedor_transfer: {
      titulo: "Bus tickets | Buy your ticket at the best price",
      subtitulo: "Reserve your transfer at the best price!",
      subtitulo2: "Chile and Argentina",
      cupones_descuentos_titulo: "Coupons & Discounts",
      cupones_descuentos_texto_1: "Every time you travel you accumulate points",
      cupones_descuentos_texto_2: "(Frequent flyer program).",
      ahorra_dinero_titulo: "Save money",
      ahorra_dinero_texto: "We compare other travel websites to give you the best price.",
      sitio_seguro_titulo: "Safe zone",
      sitio_seguro_texto: "Chilepasajes.cl has an EV SSL security certificate.",
      titulo_principal: "Find cheap bus tickets",
      titulo_principal2: "for your next trip",
      ultimasBusquedas: "Last searches performed",
      a: " to ",
      transferPara: "Transfer for the ",
      aLas: " at ",
      hrs: " hrs."
    },
    list_services: {
      capacidad: "Capacity",
      pasajeros: "passenger(s)",
      desde: "From",
      cant_pasajeros: "Passenger quantity",
      reservar: "Reserve"
    },
    barra_busqueda: {
      origen: "Origin",
      destino: "Destination",
      fecha_ida: "Dep. Date",
      fecha: "Date",
      hora: "Time",
      fecha_vuelta: "Return (Optional)",
      horaIda: "Dep. time",
      placeholderIda: "Select origin",
      placeholderVuelta: "Select destination",
      placeholderFechaIda: "Departure date",
      placeholderFechaVuelta: "Return date",
      ingresaOrigen: "Enter your <b>Origin</b>",
      ingresaDestino: "Enter your <b>Destination</b>",
      buscar: "Search",
      placeholderIdaT: "Enter or Select origin",
      placeholderVueltaT: "Enter or Select destination",
      pasajes_en_bus: "Bus tickets",
      a: "to",
      para_el_dia: "for",
      modificar: "Change"
    },
    pre_nav: {
      salidas: "Departures",
      salida: "Departure",
      salidas_text: "Select your trip",
      salidas_reg: "Departures Back",
      salidas_text_reg: "Select your travel",
      pago: "Payment",
      pago_text: "Select your payment method",
      confirmacion: "Confirmation",
      confirmacion_text: "Purchase Confirmation",
      ida: "Going",
      regreso: "Return",
      seleccionada: "selected",
      llegada: 'Arrival'
    },
    tarjeta_empresa: {
      primera_salida: "First departure",
      ultima_salida: "Last departure",
      duracion: "Duration",
      salidas: "Exits",
      salida: "Exit"
    },
    filtros: {
      embarque: "Electronic board.",
      embarque_text: "Allows you to board the bus without having a printed ticket",
      precio: "Price",
      horario: "Schedule",
      empresas: "Companies",
      salidas_desde: "Departures from",
      servicios: "Services",
      servicio: "Service",
      desde: "From",
      operador: "Operators",
      clase: "Class",
      limpiar_filtros: "Clean filters",
      cargando: "We are looking for the best price... 🚀",
      cargando_2: "Please wait !!!",
      mañana: "Early",
      tarde: "Afternoon",
      noche: "Evening",
      madrugada: "Early morning",
      mejor_precio: "Best Price",
      elegir: "Choose",
      seleccionar: "Select",
     
    },
    asientos: {
      primer_piso: "First floor",
      segundo_piso: "Second floor",
      disponible: "Available",
      seleccionado: "Selected",
      reservado: "Reserved",
      num_asiento: "N° Seat: ",
      tarifa_clp: "Tariff CLP: ",
      tarifa_usd: "Tariff USD: ",
      tipo_asiento: "Seat Type: ",
      continuar: "Continue",
      pasillo: "AISLE",
      ida: "GOING",
      vuelta: "LAP",
      conductor: "Driver",
      cargando: "Loading seats ..."
    },
    tarjeta_pago: {
      ida: "Going",
      regreso: "Return",
      pasajero: "Passenger",
      asiento: "Seat",
      pasaporte: "Passport/Others",
      rut: "Rut",
      rutPlaceholder: "Rut",
      nombre: "Name",
      nombrePlaceholder: "Name",
      apellido: "Last name",
      pais: "Country",
      subida: "Rise",
      bajada: "Descent",
      misPasajeros: "My passengers",
      comprador: "Buyer Information",
      telefono: "Telephone",
      telefonoPlaceholder: "Telephone",
      correo: "Email",
      confirmar_correo: "Confirmate Email",
      cupon: "Discount coupon",
      aplicarCupon: "Apply coupon",
      detalleCompra: "Purchase detail",
      SubTotal: "Subtotal",
      descuento: "Discount",
      totalCompra: "Total purchase",
      pagarCompra: "Pay purchase",
      terminos: "Terms and conditions.",
      terminos_text: `By clicking on "Pay Purchase" you accept the`,
      regresar: "Return",
      minimo_digitos: "Minimum 8 digits",
      maximo_digitos12: "Maximum 12 digits",
      maximo_digitos15: "Maximum 15 digits",
      maximo_digitos9: "Maximum 9 digits",
      rut_invalido: "Rut invalid",
      requerido: "Required",
      correo_invalido: "Email invalid",
      correos_diferentes: "The emails must be the same",
      solo_letras: "Only letters",
      fecha_nacimiento: "Birth date",
      telefono_invalido: "Invalid phone",
      pago: "Pay",
      metodosPago: "Different payment options",
      seguro: "Secure",
      viajeAeropuerto: 'Bus Trip To The Airport',
      extra: 'Add to purchase'
    },
    medio_pago: {
      distintasOpciones: "Different payment options",
      EstasSon: "These are the options through which you can make your purchases, just enter your data."
    },
    gestion_boletos:{
      titulo: 'Ticket Management',
      inicio: 'Home',
      servicio_cliente: 'Customer service',
      informacion: 'Purchase information',
      codigo_compra: 'Purchase code',
      requerido: 'Required',
      correo: 'Email',
      correo_info: 'Email used in the purchase',
      correo_invalido: 'Invalid email',
      buscar: 'Search'
    },
    servicio_cliente:{
      titulo: 'Customer Service',
      inicio: 'Home',
      busqueda: {
        titulo: 'Search',
        buscar_sitio: 'Search in the site',
        duda: 'Do you have any questions about how to perform a search?',
        comoBuscar: 'How to do a search?',
        infoBuscar: 'To perform a search on our site, you only need to \nEnter the city of origin, your destination and the date. He \nwill show you a complete summary of the bus offer \nthat exists for that day. If you want to buy a \nround trip ticket, just enter a return date.',
        cambiarBuscar: 'I did a search and now I want to change it. How \ndo I do it?',
        infoCambiar: 'You just have to enter the new route in the search system at the top of the page.',
        demoraBuscar: 'The search takes some time. Why?',
        infoDemora: 'To find the trip you are looking for, we have to gather \na lot of information and communicate online with each one \nof the bus companies that operate the desired route, \nSometimes these companies take a while to answer calls. \nand that generates a longer time to show the \nresults, you just have to wait.',
        filtrar: 'Can I sort and filter my results?',
        infoFiltrar: 'Yes, you can sort and filter your results by applying \ndifferent filters. These filters are: price, service \nand time. You can find them on the left side of the \npage showing the results. to make your \neven more precise search you can use the schedule \nexit and/or the maximum/minimum price bar and adjust \nyour results.'
      },
      pago: {
        titulo: 'Payments',
        ayuda: 'Help with your purchasing process?',
        metodos: 'What payment methods does Chilepasajes.cl offer?',
        webPay:{
          titulo: 'WebPay',
          info: 'It is the most common payment method and \nsafe in Chile. We recommend it for our \nclients who have a Chilean bank account \nbecause the purchase currency is the Chilean Peso (CLP) \nand WebPay does not allow returns abroad. \nYou can pay your tickets with your bank account \nChilean, your credit or debit card.'
        },
        infoPaypal:'It is the most common payment method and \nsafe worldwide. We recommend it for \nour clients from abroad, because the currency \npayment is US dollar and PayPal does not \nhas regional limits for refund as WebPay',
        tarjetaHites:{
          titulo: 'Card Hites',
          info: 'This purchase is processed by Hites'
        }
      }
      ,
      pasajes: {
        titulo: 'Ticket shipping',
        ayuda: 'Do you need help with your tickets?',
        demoraPasajes: {
          titulo: 'How do I receive my ticket and how long does it take?',
          texto1: 'Upon completion of your purchase you can immediately download your receipt in PDF format.',
          textoNegrita1: 'We recommend downloading your ticket immediately.',
          texto2:'Simultaneously, you will be sent a confirmation email that includes your voucher/ticket and Boarding pass and travel information. Additionally, if you have a smartphone with Android or iOS system, you can download your ticket in the Chilepasajes app and enter the bus with a mobile ticket if the bus company allows it.',
          texto3: 'If you do not receive the ticket, we recommend that you check your email inbox and if the ticket was mistakenly classified as SPAM, move it to your inbox.',
          texto4:"If that doesn't help or if you entered your email incorrectly at the time of purchase, you have to write to us at least 24 hours before the bus leaves at ",
          texto5: 'or contact us at the following customer service number:',
          texto6: 'to resend your ticket.'
        }
      },
      cancelaciones: {
        titulo: 'Cancellations',
        duda: 'Do you have any questions about your cancellation?',
        botonCancelar: 'Cancel tickets',
        pregunta1:{
          titulo:'I want to cancel my ticket and receive a refund, what things do I have to consider?',
          texto1: 'You have to review the cancellation conditions described in the passage. Generally, you can cancel each ticket through chilepasajes.cl by entering',
          texto2: 'Each bus company accepts cancellations of national trips up to 4 hours before departure, along with a 15% retention. In the case of international trips, the advance notice to cancel the ticket can be up to 72 hours before the bus departure. We recommend carefully reviewing the cancellation conditions in the case of your trip.',
        },
        pregunta2:{
          titulo: 'How can I cancel my ticket?',
          texto1: 'You just have to click on the link',
          texto2: 'in the "Customer Service" section on our home page. Remember that you can only cancel your ticket if the cancellation meets the cancellation conditions, especially that it meets the lead time before the bus departure. Then you have to enter the email you used and your purchase code and click "Search". Then we show you the tickets that can be cancelled. To cancel your ticket you have to click on “Cancel ticket” next to the ticket you want to cancel, choose between Coupon or Bank Deposit. To complete the cancellation, it is important that you enter your bank details to make the return (only if you purchased via WebPay). Afterwards chilepasajes.cl will confirm the cancellation by sending you an email.'
        },
        pregunta3:{
          titulo: 'How does the return process work?',
          texto1: 'The refund process depends on the payment method you used to purchase your ticket:',
          texto2: 'The deposit period is 5 business days in the case of a debit card purchase, while if you purchased with a credit card the period is 10 business days. The period starts from the business day after receiving your bank details for transfer. If after this period you have any problem with your payment, do not hesitate to contact us at ayuda@chilepasajes.cl, indicating the purchase number. and your bank details (account holder, RUT of the holder, name of the bank, type of account).',
          texto3: 'The refund will be made to the PayPal account that the customer used for the purchase. In case you do not receive the refund in your account 7 days after your cancellation, please contact us through ayuda@chilepasajes.cl, indicating the purchase number and your PayPal account.'
        }
      },
      preguntas:'Still have a question?',
      infoPregunta:"If you can't find a question in our FAQ, you can always contact us. We will respond to you shortly!",
      infoTel: 'We are always happy to help!',
      infoMail: 'The best way to get a quick response!'
    },
    footer:{
      tituloBoletos: 'Manage your tickets: cancel, change, change whereabouts, etc.',
      tituloTermYcond: 'Read the Terms and Conditions of use of the site.',
      tituloPrivacidad: "Read the site's Privacy Policy.",
      tituloBuses: 'Go to the ticket search engine',
      tituloTransfer:'Go to transfer search',
      tituloCookies: "Read the site's Cookie Policy",
      tituloInfo: 'Read useful information about the site',
      tituloVolver: 'Return to top of page',
      tituloFacebook: 'Go to the ChilePasajes Facebook page',
      tituloX: 'Go to the ChilePasajes X page',
      tituloInstagram: 'Go to the ChilePasajes Instagram page',
      tituloYoutube: 'Go to the ChilePasajes YouTube Channel'
    },
    login: {
      bienvenido: "Welcome to Chilepasajes.cl! 👋",
      inicia: "Log in to your account and start the adventure of traveling with us.",
      contrasena: "Password",
      recordarme: "Remember me",
      ingresar: "Log in",
      aceptarTerminos: "By logging in, you agree to our",
      terminosUso: "terms of use",
      politicas: "privacy policy",
      nuevo: "New to the platform?",
      crearCuenta: "Create an account",
      recuperar: 'Recover password'
    }
    ,
    empresas:
    {
      pasajesen:"pasajes en "
    }
  }
}
